module.exports = __webpack_public_path__ + "static/media/book3.eb5fb804.jpg";